import React, { useEffect } from "react";
import "./changePhoneNo.scss";
import { Stack, TextField, Grid, Box } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useState } from "react";
import authStore from "../../../store/authStore";
import brandStore from "../../../store/brandStore";
import { Link, useNavigate } from "react-router-dom";
import { BRAND_NAME_LOGO } from "../../../constant";

const ChangePhoneNo = () => {
  const navigate = useNavigate();
  const AuthStore = authStore();
  const BrandStore = brandStore();
  const [isLoading, setIsLoading] = useState(false);
  const [isPhoneNumberError, setIsPhoneNumberError] = useState(false);
  const [phoneNumberMassage, setPhoneNumberMassage] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  useEffect(() => {
    if (AuthStore.whereNavigate === null) {
      navigate("/user/manage-account", { replace: true });
    }
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (phoneNumber === "") {
      setPhoneNumberMassage("phone no is required");
      setIsPhoneNumberError(true);
      setIsLoading(false);
    } else {
      if (phoneNumber.length === 10) {
        if (phoneNumber === AuthStore.myUser.phoneNumber) {
          setPhoneNumberMassage("please write new phone no");
          setIsPhoneNumberError(true);
          setIsLoading(false);
        } else {
          setIsPhoneNumberError(false);
          await AuthStore.changeUserPhoneNo({ phoneNumber });
          setIsLoading(false);
          navigate(-1, { replace: true });
        }
      } else {
        setPhoneNumberMassage("Phone no must be 10 digit");
        setIsPhoneNumberError(true);
        setIsLoading(false);
      }
    }
  };

  return (
    <div className="change-phone-no">
      <Grid container sx={{ display: "flex", justifyContent: "center" }}>
        <Grid item md={6} sm={8} xs={12}>
          <Stack spacing={2}>
            <Box component="div" className="brand-name-logo-container">
              <Link to={"/"} component="div" className="brand-name-logo">
                <img src={BRAND_NAME_LOGO} alt="brand-logo" />
              </Link>
            </Box>
            <div className="title">Enter New Phone No</div>
            <TextField
              id="phoneNumber"
              name="phoneNumber"
              inputProps={{ inputMode: "numeric", maxLength: 10 }}
              required
              fullWidth
              label="Phone No"
              autoComplete="phone"
              error={isPhoneNumberError}
              helperText={isPhoneNumberError && phoneNumberMassage}
              value={phoneNumber}
              onChange={(e) => {
                if (!isNaN(e.target.value)) {
                  setPhoneNumber(e.target.value);
                }
              }}
            />
            <LoadingButton
              loading={isLoading}
              className="btn"
              variant="contained"
              type="submit"
              onClick={onSubmit}
            >
              Submit
            </LoadingButton>
          </Stack>
        </Grid>
      </Grid>
    </div>
  );
};

export default ChangePhoneNo;
